import { AuthService } from "../services/auth.service";

export function authHeader() {
  const currentToken = AuthService.currentUserToken;
  console.log("currentUser token", currentToken);
  if (currentToken) {
    return { Authorization: `Bearer ${currentToken}` };
  } else {
    return {};
  }
}
